import { useSyncExternalStore } from "react";

// Whether the API was reachable at the last attempt (WEB-F-SH-05). Set by the query cache: a NetworkError marks
// it lost, any success restores it. The browser's own offline event counts too.
let lost = typeof navigator !== "undefined" && navigator.onLine === false;
const listeners = new Set<() => void>();

export function setConnectionLost(value: boolean): void {
  if (value === lost) return;
  lost = value;
  for (const l of listeners) l();
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  const off = () => setConnectionLost(true);
  const on = () => setConnectionLost(false);
  window.addEventListener("offline", off);
  window.addEventListener("online", on);
  return () => {
    listeners.delete(l);
    window.removeEventListener("offline", off);
    window.removeEventListener("online", on);
  };
}

export function useConnectionLost(): boolean {
  return useSyncExternalStore(subscribe, () => lost);
}
